import { environment } from '@/config';
import { LOCAL, DEMO, PREPROD, PROD } from '@/assets/common/environment';

export const state = () => ({
    LOCAL,
    DEMO,
    PREPROD,
    PROD
});

export const getters = {
    LOCAL: state => state.LOCAL,
    DEMO: state => state.DEMO,
    PROD: state => state.PROD,
    isDemo: state => state.DEMO === environment,
    isProd: state => state.PROD === environment,
    isPreprod: state => state.PREPROD === environment,
    isProdOrPreprod: state => state.PREPROD === environment || state.PROD === environment,
    current: () => environment
};

export const mutations = {};

export const actions = {};
